<template>
  <div style="position: relative;">
    <div v-if="!iframeLoaded && iframeConfig.src" class="preloadFilter">
      <Loading />
    </div>
    <IFrameResizer
      v-if="iframeConfig.src"
      v-show="iframeLoaded"
      :config="iframeConfig"
      class="shopIFrame"
      @loaded="iframeLoaded = true"
    />
  </div>
</template>

<script>
import IFrameResizer from "../IFrameResizer/IFrameResizer";
import Loading from "../Loading/Loading";
import CustomEvents from "../../globals/constants/customEvents";
import ShopPostMessages, {
  ShopQueryActionType
} from "../../globals/constants/shopPostMessages";
import "url-polyfill";
import axios from "axios";
import reactivateOldBasketByUrl from "../../xhr/shopCart/reactivateOldBasketByUrl";

export default {
  name: "ShopIFrame",
  components: {
    IFrameResizer,
    Loading
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      messagesToPost: [],
      iframeLoaded: false,
      registerPagePath: "/customer/account/create/",
      forgotPasswordPagePath: "/customer/account/forgotpassword/",
	  accountConfirmationResendPath: "/customer/account/confirmation/",
      accountPagePath: "/customer/account",
      accountEditPagePath: "/customer/account/edit",
      addressPagePath: "/customer/address",
      cartPagePath: "/checkout/cart/",
      orderHistoryPagePath: "/sales/order/history",
      successPagePath: "/checkout/onepage/success",
      successPagePathCw: "/computopcw/checkout/success",
      confirmNewAccountPage: "/customer/account/confirm/",
      createNewPasswordPage: "/customer/account/createPassword/",
      iframeConfig: {
        id: "webShop",
        width: "100%",
        height: "980px",
        src: null
      }
    };
  },
  methods: {
    setSource() {
      const queries = window.location.search.substring(1).split("&");
      let actionType = "";
      if (queries) {
        for (const query of queries) {
          if (query.includes(ShopQueryActionType.ACTION_TYPE)) {
            actionType = query.split("=")[1].toLowerCase();
            switch (actionType) {
              case ShopQueryActionType.REGISTER.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.registerPagePath;
                break;
              case ShopQueryActionType.FORGOT_PASSWORD.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.forgotPasswordPagePath;
                break;
			 case ShopQueryActionType.RESEND_ACTIVIATION_LINK.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.accountConfirmationResendPath;
                break;
              case ShopQueryActionType.CREATE_ACCOUNT_CONFIRM.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl +
                  this.confirmNewAccountPage +
                  window.location.search;
                break;
              case ShopQueryActionType.CREATE_PASSWORD.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl +
                  this.createNewPasswordPage +
                  window.location.search;
                break;
              case ShopQueryActionType.SUCCESS_PAYMENT.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.successPagePath;
                break;
              case ShopQueryActionType.SUCCESS_PAYMENT_CW.toLowerCase():
                var parameterTxIDValue =
                  decodeURIComponent(
                    (new RegExp(
                      "[?|&]" + "cstrxid" + "=" + "([^&;]+?)(&|#|;|$)"
                    ).exec(window.location.search) || [null, ""])[1].replace(
                      /\+/g,
                      "%20"
                    )
                  ).toLowerCase() || null;
				  var parameterSecretValue =
                  decodeURIComponent(
                    (new RegExp(
                      "[?|&]" + "secret" + "=" + "([^&;]+?)(&|#|;|$)"
                    ).exec(window.location.search) || [null, ""])[1].replace(
                      /\+/g,
                      "%20"
                    )
                  ).toLowerCase() || null;
                this.iframeConfig.src =
                  this.config.shopBaseUrl +
                  this.successPagePathCw +
                  "/?cstrxid=" +
                  parameterTxIDValue + "&secret=" + parameterSecretValue;
                break;
              case ShopQueryActionType.ACCOUNT.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.accountPagePath;
                break;
              case ShopQueryActionType.ACCOUNT_EDIT.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.accountEditPagePath;
                break;
              case ShopQueryActionType.ADDRESS.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.addressPagePath;
                break;
              case ShopQueryActionType.HISTORY.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.orderHistoryPagePath;
                break;
              case ShopQueryActionType.SHOW_CART.toLowerCase():
                this.iframeConfig.src =
                  this.config.shopBaseUrl + this.cartPagePath;
                break;
              case ShopQueryActionType.CANCEL_PAYMENT.toLowerCase():
                this.handleCancelPayment();
                break;
              default:
                this.iframeConfig.src = null;
            }
          }
        }
      }
    },
    postCancelPaymentMessage() {
      const iframe = document.getElementById(this.iframeConfig.id);
      if (iframe) {
        const postMessage = () => {
          iframe.contentWindow.postMessage(
            ShopPostMessages.SHOW_CANCEL_PAYMENT_MESSAGE,
            "*"
          );
          iframe.removeEventListener("load", postMessage, false);
        };

        iframe.addEventListener("load", postMessage, false);
        this.unregisterMessageToPost(this.postCancelPaymentMessage);
      }
    },
    handleCancelPayment() {
      reactivateOldBasketByUrl(window.reactivateOldBasketUrl)
        .then(() => {
          this.iframeConfig.src = this.config.shopBaseUrl + this.cartPagePath;
          const timeOut = setTimeout(() => {
            window.dispatchEvent(
              new CustomEvent(CustomEvents.UPDATE_SHOP_CART, null)
            );
            this.registerMessageToPost(this.postCancelPaymentMessage);
            clearTimeout(timeOut);
          }, 2000);
        })
        .catch(error =>
          console.error(
            "Could not reactivate old basket from ShopIframe.",
            error
          )
        );
    },
    receiveMessage(event) {
      const shopBaseUrl = new URL(this.config.shopBaseUrl || location.origin);
      if (
        event.origin === shopBaseUrl.origin &&
        event.data.toUpperCase() === ShopPostMessages.GET_CART
      ) {
        const timeOut = setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent(CustomEvents.UPDATE_SHOP_CART, null)
          );
          clearTimeout(timeOut);
        }, 2000);
      } else if (
        event.origin === shopBaseUrl.origin &&
        event.data.toUpperCase() === ShopPostMessages.REDIRECT_TO_BASE_URL
      ) {
        window.top.location.href = window.top.location.href.substring(
          0,
          window.top.location.href.lastIndexOf("/")
        );
      } else if (
        event.origin === shopBaseUrl.origin &&
        event.data.toUpperCase().includes(ShopPostMessages.SCROLL_TOP)
      ) {
        const timeOut = setTimeout(() => {
          $("html, body").animate(
            { scrollTop: event.data.replace("SCROLLTOP_", "") },
            "slow"
          );
          clearTimeout(timeOut);
        }, 700);
      }
    },
    registerMessageToPost(messageFunction) {
      if (this.messagesToPost.indexOf(messageFunction) === -1) {
        this.messagesToPost.push(messageFunction);
      }
    },
    unregisterMessageToPost(messageFunction) {
      this.messagesToPost = [
        ...this.messagesToPost.filter(message => message !== messageFunction)
      ];
    }
  },
  updated() {
    if (this.messagesToPost && this.messagesToPost.length) {
      this.messagesToPost.map(message => message());
    }
  },
  mounted() {
    this.setSource();
    window.addEventListener("message", this.receiveMessage, false);
  },
  destroyed() {
    window.removeEventListener("message", this.receiveMessage, false);
  }
};
</script>
